import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { AdviserComponent }  from './adviser.component';
import { AdviserModel }      from './typings/adviser';
import { AdvisersComponent } from './advisers.component';
import { AdvisersService }   from './advisers.service';
import { TableService }      from '../table/table.service';

export const AdvisersStates : Array<NgHybridStateDeclaration> = [
  {
    component: AdviserComponent,
    name     : 'app.adviser',
    params   : {
      id: {
        squash: true,
        value : null
      }
    },
    resolve: [
      {
        deps     : [ AdvisersService, Transition ],
        resolveFn: ( advisersService : AdvisersService, transitionService : Transition ) : ng.IPromise<AdviserModel> => {
          const id = transitionService.params().id;

          return id
            ? advisersService.getById(id)
            : Promise.resolve({} as AdviserModel);
        },
        token: 'adviser'
      }
    ],
    url: '/adviser/:id'
  },
  {
    component: AdvisersComponent,
    name     : 'app.advisers',
    resolve  : [
      {
        deps     : [ AdvisersService, TableService ],
        resolveFn: ( advisersService : AdvisersService, tableService : TableService ) : ng.IPromise<Array<AdviserModel>> => {
          const cache = tableService.getCacheForTable('advisers');

          return advisersService.get({
              direction: cache.sorting.direction,
              field    : cache.sorting.field,
              offset   : 0,
              pageSize : cache.paging.pageSize
            });
        },
        token: 'advisers'
      }
    ],
    url: '/advisers'
  }
];